import type { ILink } from "../../entities/link.entity";
import { deleteLinkById } from "../../utils/firebase";
import { useMutation } from "@tanstack/react-query";
import { useLinksList } from "./useLinksList";
import { enqueueSnackbar } from "notistack";
import { captureException } from "@sentry/react";

export const useLinkRemover = () => {
	const linksList = useLinksList();
	return useMutation({
		mutationKey: ["links", "delete"],
		mutationFn: async (link: ILink) => {
			await deleteLinkById(link.id);
		},
		onError: (error) => {
			captureException(error);
			enqueueSnackbar({
				variant: "error",
				message: "Erro ao deletar link, tente novamente",
			});
		},
		onSuccess: () => {
			linksList.refetch();
			enqueueSnackbar({
				variant: "success",
				message: "Link deletado com sucesso",
			});
		},
	});
};
